module.exports = __webpack_public_path__ + "img/arrow.6f976ef6.svg";